import React, {useState} from 'react';

//Component
import { GridContainer, GridItem, ProductCard, ImageButton, ServiceRequestDialog } from '../../components';
import Typography from '@material-ui/core/Typography';
import { CardType } from 'models/type/ProductCardType';
import eventsImage from 'images/upsell_Items/events.jpg';
import LateCheckoutImage from 'images/upsell_Items/lateCheckOut.jpg';
import { UpsellTitles } from 'models/backend/constant/Upsell';
import { IconButton, Snackbar } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { RoomUpgrade } from 'models/RoomUpgrade';
import { Food } from 'models/Food';
import { Facilities } from 'models/Facilities';
import { getVerbiage } from 'utils/stringHelper';
import { useSelector } from 'react-redux';
import { RootState } from 'reducers';

interface IProps{
  data: any[];
};

function isRoomUpgrade(data: any) : data is RoomUpgrade{
  return (
    'id' in data &&
    'name' in data &&
    'details' in data &&
    'price' in data &&
    'image' in data &&
    !('quantity' in data) &&
    !('hourBooking' in data)
  );
};

function isRoomService(data: any): data is Food {
  return (
    'id' in data &&
    'name' in data &&
    'details' in data &&
    'price' in data &&
    'image' in data &&
    'quantity' in data
  );
};

function isFacility(data: any): data is Facilities {
  return (
      'hourBooking' in data
  );
};

export const UpsellDetail: React.FC<IProps> = ({data}) => {
  const { verbiages } = useSelector((state: RootState) => state.verbiages);
  const [selectedRoom, setSelectedRoom] = useState<RoomUpgrade | null>(null);
  const [selectedFacilities, setSelectedFacilities] = React.useState<CardType[]>([]);
  const [openServiceRequestDialog, setOpenServiceRequestDialog] = React.useState(false);
  const [message, setMessage] = React.useState('');
  const [openSnackBar, setOpenSnackBar] = React.useState(false);
  const [isRoomUpgradeDataExist, setIsRoomUpgradeDataExist] = React.useState(false);
  const [isRoomServiceDataExist, setIsRoomServiceDataExist] = React.useState(false);
  const [isFacilityDataExist, setIsFacilityDataExist] = React.useState(false);
  
  const handleRoomSelect = (room: CardType | null) => {
    if(selectedRoom!=null && selectedRoom.id === room?.id){
        setSelectedRoom(null);
    }
    else{
        setSelectedRoom(room);
    }
  };

  const handleFacilitiesSelect = (selectedFacility: CardType) => {
    const isSelected = selectedFacilities.some((facility) => facility.id === selectedFacility.id);
    if (isSelected) {
      setSelectedFacilities(selectedFacilities.filter((facility) => facility.id !== selectedFacility.id));
    } else {
      setSelectedFacilities([...selectedFacilities, selectedFacility]);
    }
  };

  const handleClose = () => {
    setMessage('');
    setOpenSnackBar(false);
  };

  const onServiceRequestCompleted = async (isCompleted: boolean, snackBarMessage: string) => {
    setOpenServiceRequestDialog(false);
      if(isCompleted === true){
        if(snackBarMessage != ""){
          setMessage(snackBarMessage);          
        }        
        else{
          setMessage("No Service Requested!"); 
        }
        setOpenSnackBar(true);
      }
  };

  const handleOnEventClick = () =>{
    window.open('https://www.klook.com/en-SG/search/result/?query=singapore&spm=Home.TopNavigation.SearchInput&clickId=53981abf7d', '_blank');
  };

  const handleOnLateCheckOutClick = () =>{
    setOpenServiceRequestDialog(true);
  };

  React.useEffect(()=>{
    const roomUpgradeExists = data.some(item => isRoomUpgrade(item));
    setIsRoomUpgradeDataExist(roomUpgradeExists);

    const roomServiceExists = data.some(item => isRoomService(item));    
    setIsRoomServiceDataExist(roomServiceExists);

    const facilityExists = data.some(item => isFacility(item));
    setIsFacilityDataExist(facilityExists);
    console.log("1 " + isRoomUpgradeDataExist);
  }, [data]);

  return (
    <GridContainer spacing={2} direction="column" style={{ minHeight: '60vh', padding: '18px' }}>
      {isRoomUpgradeDataExist ? (
        <GridItem xs={12}>
          <Typography color="textPrimary" align="left" variant="h6" style={{fontWeight: 'bold'}}>
            {/* Room Upgrade */}
            {getVerbiage(verbiages, 'weblbl104')}
          </Typography>
        </GridItem>
      ): null}
      <div>
        { data.map((item) => {
          if (isRoomUpgrade(item)){
              return(
                  <ProductCard
                    key={item.id}
                    productCard={item}
                    onSelectCard={handleRoomSelect}
                    selectedCard={selectedRoom !== null && selectedRoom.id === item.id}
                    counterButtonOn={false}
                  />          
              )               
          }
          else{
            return null;
          }
          })
        }
      </div>
      

      {isRoomServiceDataExist ? (
        <GridItem xs={12}>
          <Typography color="textPrimary" align="left" variant="h6" style={{fontWeight: 'bold'}}>
            {/* Room Service */}
            {getVerbiage(verbiages, 'weblbl105')}
          </Typography>
        </GridItem>
      ): null}
      <div>
        { data.map((item) => {
          if (isRoomService(item)){
              return(
                  <ProductCard
                    key={item.id}
                    productCard={item}
                    counterButtonOn={true}
                  />          
              )               
          }
          else{
            return null;
          }
          })
        }
      </div>      

      {isFacilityDataExist ? (
        <GridItem xs={12}>
          <Typography color="textPrimary" align="left" variant="h6" style={{fontWeight: 'bold'}}>
            {/* Facility Booking */}
            {getVerbiage(verbiages, 'weblbl106')}
          </Typography>
        </GridItem>
      ): null}      
      <div>
        { data.map((item) => {
          if (isFacility(item)){
              return(
                  <ProductCard
                    key={item.id}
                    productCard={item}
                    onSelectCard={handleFacilitiesSelect}
                    selectedCard={selectedFacilities.some((facility) => facility.id === item.id)}
                    counterButtonOn={false}
                  />          
              )               
          }
          else{
            return null;
          }
          })
        }
      </div>

      <GridItem xs={12}>
        <Typography color="textPrimary" align="left" variant="h6" style={{fontWeight: 'bold'}}>
          {/* Other Services */}
          {getVerbiage(verbiages, 'weblbl107')}
        </Typography>
      </GridItem>      
      <GridItem>
        <ImageButton imageUrl={LateCheckoutImage} title="LateCheckOut" onClicked={handleOnLateCheckOutClick} style={{width: "50%"}}/>
        <ImageButton imageUrl={eventsImage} title="Events" onClicked={handleOnEventClick} style={{width: "50%"}}/>
      </GridItem>

      <ServiceRequestDialog
        open={openServiceRequestDialog}
        onCompleted={onServiceRequestCompleted}
        title = {UpsellTitles.LateCheckOut}
      />
      <GridItem xs={12}>
          <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={openSnackBar}
            onClose={handleClose}
            autoHideDuration={5000}
            message={message}
            action={
              <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose}>
                <CloseIcon fontSize="small" />
              </IconButton>
            }
          />
        </GridItem>
    </GridContainer>

    
  );
};
